// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductPreviewButtons_root__1cPfG","productPreview":"ProductPreviewButtons_productPreview___0MYH"};